import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {
  Typography,
  makeStyles,
  Paper,
} from "@material-ui/core";

import LiveEventsCard from "./LiveEventsCard";
import AppContainer from "../../../AppContainer";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
  },

  showMoreContainer: {
    marginTop: theme.spacing(3),
  },

  emptyContainer: {
    width: "100%",
    marginTop: theme.spacing(2),
    padding: theme.spacing(4, 2),
    textAlign: "center",
    borderRadius: 12,
  },

  emptyTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },

  emptyText: {
    color: "#777",
    maxWidth: 600,
    margin: "0 auto",
  },

  "@media (max-width: 600px)": {
    title: {
      fontSize: "2rem",
    },

    emptyContainer: {
      padding: theme.spacing(3, 2),
    },
  },
}));

const getEventDate = (fechaEvento) => {
  if (!fechaEvento) return null;

  let date;

  if (typeof fechaEvento === "string") {
    const cleanDate = fechaEvento.trim().replace(/\//g, "-");

    date = new Date(cleanDate);

    if (isNaN(date.getTime())) {
      const parts = cleanDate.split("-");

      if (parts.length >= 3) {
        date = new Date(
          Number(parts[0]),
          Number(parts[1]) - 1,
          Number(parts[2].substring(0, 2))
        );
      }
    }
  } else {
    date = new Date(fechaEvento);
  }

  if (isNaN(date.getTime())) {
    return null;
  }

  return date;
};

const LiveEventsList = () => {
  const classes = useStyles();

  const eventsFirebase = useSelector(
    (state) => state.events.events
  );

  const [eventosMostrados, setEventosMostrados] = useState(20);

  const events = useMemo(() => {
    if (!eventsFirebase) return [];

    return Object.keys(eventsFirebase)
      .map((key) => ({
        ...eventsFirebase[key],
        firebaseKey: key,
      }))
      .filter(
        (evento) =>
          Number(evento.eventoDisponible) === 4
      )
      .sort((a, b) => {
        const fechaA = getEventDate(a.fechaEvento);
        const fechaB = getEventDate(b.fechaEvento);

        if (!fechaA && !fechaB) return 0;
        if (!fechaA) return 1;
        if (!fechaB) return -1;

        return fechaB.getTime() - fechaA.getTime();
      });
  }, [eventsFirebase]);

  const eventsToShow = useMemo(() => {
    return events.slice(0, eventosMostrados);
  }, [events, eventosMostrados]);

  const handleMostrarMas = () => {
    setEventosMostrados(
      (prevState) => prevState + 20
    );
  };

  return (
    <AppContainer>
      <Typography
        color="primary"
        variant="h2"
        component="h2"
        className={classes.title}
      >
        Eventos en vivo
      </Typography>

      {events.length === 0 ? (
        <Paper
          elevation={0}
          className={classes.emptyContainer}
        >
          <Typography
            variant="h6"
            color="primary"
            className={classes.emptyTitle}
          >
            No hay eventos en vivo
          </Typography>

          <Typography
            variant="body1"
            className={classes.emptyText}
          >
            En este momento no hay eventos en ejecución que estén
            transmitiendo resultados de forma pública.
          </Typography>
        </Paper>
      ) : (
        <>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            {eventsToShow.map((evento) => (
              <LiveEventsCard
                key={
                  evento.iDEvento ||
                  evento.firebaseKey
                }
                evento={evento}
              />
            ))}
          </Grid>

          {eventsToShow.length < events.length && (
            <div className={classes.showMoreContainer}>
              <Button
                color="primary"
                fullWidth
                variant="contained"
                onClick={handleMostrarMas}
              >
                Mostrar más eventos en vivo
              </Button>
            </div>
          )}
        </>
      )}
    </AppContainer>
  );
};

export default LiveEventsList;